import errorModel from "../../model/ErrorModel";
import { ICondition } from "../State";

export class HasErrorCondition implements ICondition {
    public check(): boolean {
        return errorModel.hasError();
    }
}
